import { render } from "./generate-nextyear-compliance-model.html?vue&type=template&id=7dbf6505&scoped=true&ts=true&external"
import script from "./generate-nextyear-compliance-model.ts?vue&type=script&lang=ts&external"
export * from "./generate-nextyear-compliance-model.ts?vue&type=script&lang=ts&external"

import "./generate-nextyear-compliance-model.scss?vue&type=style&index=0&id=7dbf6505&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbf6505"]])

export default __exports__